import * as yup from "yup";

export const VALIDATION_SCHEMA = yup.object({
  name: yup
    .string()
    .required("This field is required!")
    .max(255, "Table name must be less than 255 characters!"),
  rows: yup.array().min(1, "Table data cannot be empty!"),
});
